import script from "./StatBlock.vue?vue&type=script&setup=true&lang=ts"
export * from "./StatBlock.vue?vue&type=script&setup=true&lang=ts"

import "./StatBlock.vue?vue&type=style&index=0&id=4f66b178&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f66b178"]])

export default __exports__